import { connect } from "react-redux";
import LocationType from "./../LocationType";
import _ from "lodash";
import MediaInput from "./MediaInput";
import { updateMediaValue } from "./../../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	//TODO selectors/reducers
	const surveyProgress = state.survey.surveyManager.surveyProgress;
	const locationTypes = surveyProgress.locationTypes || [];
	const locationTypeDataIndex = _.findIndex(locationTypes, {
		locationTypeId: ownProps.locationType.locationTypeId,
	});
	const locationTypeData =
		locationTypeDataIndex !== -1 ? locationTypes[locationTypeDataIndex] : {};
	const locationType = new LocationType(locationTypeData);

	const quantity = locationType.getMediaQuantity(
		ownProps.statement,
		ownProps.type
	);

	return {
		quantity: quantity,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		updateMediaValue: value => {
			dispatch(
				updateMediaValue(
					ownProps.locationType,
					ownProps.statement,
					ownProps.type,
					value
				)
			);
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MediaInput);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/MediaInputContainer.js